import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import {ThemeProvider} from "@mui/material";
import theme from "./utils/theme/theme";
import {RouterProvider} from "react-router-dom";
import router from "./utils/router/router";
import {LoadingContextProvider} from "./components/loading-context/LoadingContext";
import "./i18n/i18n";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
        <LoadingContextProvider>
            <RouterProvider router={router} />
        </LoadingContextProvider>
    </ThemeProvider>
  </React.StrictMode>
);